// eslint-disable-next-line import/prefer-default-export
export const DIVISIONS_LIST = {
  11: "Women's Apparel",
  14: 'Contemporary Apparel',
  15: "Children's",
  18: 'Intimate Apparel',
  21: 'Gifts & Home',
  27: 'Flash Sales Direct Purchase',
  34: 'Ladies Shoes',
  35: 'Designer Handbags',
  36: 'Fashion Accessories',
  44: "Men's",
  53: 'Beauty',
  56: 'Jewelry',
  77: 'Last Call Direct Purchase',
  81: 'Fine Apparel',
  98: 'Non Retail',
  99: 'NMG Miscellaneous',
};

export const GROUPS_LIST = {
  111: 'Dresses',
  112: 'Lifestyle Sportswear',
  113: 'Collection Sportswear',
  114: 'Outerwear',
  141: 'Femme Collections',
  142: 'Lifestyle',
  143: 'Core Collections',
  144: 'Advanced Collections',
  145: 'Private Label',
  151: "Children's Apparel",
  152: "Children's Accessories",
  153: 'Burberry',
  181: 'Foundations',
  183: 'Sleepwear & Lounge',
  184: 'Private Label Intimate Collections',
  185: 'Hosiery & Slippers',
  200: 'Food & Gourmet',
  201: 'Furniture & Rugs',
  202: 'Home Decor',
  203: 'Home Office',
  204: 'Seasonal',
  205: 'Tabletop',
  206: 'Linens & Bath',
  207: 'Travel',
  208: 'Gifts & Home Consignment',
  209: 'Monica Rich Kosann',
  341: 'Designer Shoes',
  342: 'Contemporary Shoes',
  343: 'Bridge Shoes',
  344: 'Special Orders/Trunk Shows Shoes',
  350: 'Chanel',
  351: 'Italian Designer Handbags',
  352: 'French Designer Handbags',
  353: 'Contemporary Handbags',
  354: 'Special Orders/Trunk Shows Handbags',
  361: 'Accessories',
  362: 'Eyewear',
  363: 'Special Orders/Trunk Shows Fashion Accessories',
  440: "Men's Shoes",
  441: "Men's Accessories",
  442: "Men's Designer Rtw",
  443: "Men's Sportswear",
  444: "Men's Contemporary Rtw",
  446: "Men's Clothing",
  530: 'Cosmetics',
  531: 'Treatment',
  532: 'Fragrance',
  533: 'Beauty Accessories',
  534: 'Bath, Body & Hair',
  560: 'Designer Jewelry Owned',
  561: 'Designer Jewelry Consigned',
  562: 'Precious Jewelry Owned',
  563: 'Precious Jewelry Consigned',
  564: 'Designer Jewelry Purchased Consigned',
  810: 'Couture Collections',
  811: 'Couture Modernist',
  812: 'Designer Collections',
  813: 'Designer Modernist',
  814: 'European Designer',
  815: 'Collezioni/Punto',
  816: 'Furs',
  817: 'Contemporary Fine Apparel',
  818: 'Bridal',
  982: 'Lease Dept',
};

export const DEPARTMENTS_LIST = {
  289: 'Lease Vendor Tips',
  300: 'Beauty Salon Lease',
  301: 'Hopemore Service',
  306: 'Beauty Salon Spa Lease',
  600: 'Beauty Salon Products',
  601: 'Hopemore Products',
  701: 'Oliver Peoples Leased',
  815: 'Product Innovation Leased',
  824: 'The Salon at Bergdorf Goodman',
  827: 'Mendel Furs Leased',
  828: 'Prada Leased',
  829: 'Prada Leased Pass Through',
  830: 'Louis Vuitton Leased',
  831: 'Louis Vuitton Leased Pass Through',
  841: 'Gucci Leased',
  842: 'Gucci Leased Pass Through',
  843: 'Celine Leased',
  844: 'Celine Leased Pass Through',
  845: 'FENDI Leased',
  846: 'FENDI Leased Pass Through',
  848: 'Atelier Notify Leased',
  850: 'Kentshire Leased',
  853: 'BLVD Leased',
  855: 'BLVD Leased Pass Through',
  858: 'SANTANA Leased',
  859: 'SANTANA Leased Pass Through',
  860: 'SMARTECH Leased',
  861: 'SMARTECH Pass Through',
  862: 'CHRISTIAN LOUBOUTIN Leased',
  863: 'CHRISTIAN LOUBOUTIN Pass Through',
  866: 'Chanel Leased',
  867: 'Chanel Leased Pass Through',
  868: 'Goyard Leased',
  869: 'Goyard Leased Pass Through',
  871: 'CHANEL Accessories MBSD Leased',
  872: 'CHANEL RTW MBSD Leased',
  873: 'Dior Leased Accessories Blended',
  874: 'Dior Leased RTW Blended',
  875: 'Dior Leased Pass Through',
  880: 'Optician Services Leased',
  881: 'Optician Services Leased',
  1101: 'Contemporary Evening',
  1102: 'Classic Evening',
  1103: 'Platinum Evening',
  1104: 'Daytime Dresses',
  1105: 'Dresses MFP Reserve',
  1106: 'Burberry Brit',
  1107: 'Eileen Fisher',
  1108: 'Leisure Sportswear',
  1109: 'Private Label Sportswear',
  1110: 'Trend Separates',
  1111: 'Denim Collections',
  1112: 'Lifestyle Sportswear MFP Reserve',
  1113: 'St. John',
  1114: 'Lafayette 148',
  1115: 'Elie Tahari',
  1116: 'American Collections',
  1117: 'European Collections',
  1118: 'Collection Sportswear MFP Reserve',
  1119: 'Moncler',
  1120: 'Classic Outerwear',
  1121: 'Trend Outerwear',
  1122: 'Outerwear MFP Reserve',
  1123: 'Lifestyle',
  1124: 'Milly',
  1125: 'Tory Burch',
  1126: 'Contemporary Collection Evening',
  1127: 'Joseph',
  1131: 'Johnny Was',
  1132: 'Equipment',
  1133: 'Premiere Evening',
  1134: 'Emporio Armani',
  1135: 'Johnny Was Consignment',
  1136: 'Emporio Armani Consignment',
  1400: 'Alice + Olivia',
  1401: 'Core Femme',
  1402: 'Femme Collections',
  1403: 'Femme Collections MFP Reserve',
  1404: 'J Brand',
  1405: 'Core Denim',
  1406: 'Separates',
  1407: 'Equipment',
  1408: 'Knitwear',
  1409: 'Swim',
  1410: 'Advanced Denim',
  1411: 'Trend Collections',
  1412: 'Veronica Beard Collection',
  1413: 'Lifestyle MFP Reserve',
  1414: 'Vince',
  1415: 'Joie',
  1416: 'Theory',
  1417: 'Core Collections MFP Reserve',
  1418: 'Helmut Lang',
  1419: 'Advanced American',
  1420: 'Advanced Collections MFP Reserve',
  1421: 'Rag & Bone Collection',
  1422: 'Advanced European',
  1423: 'Cashmere',
  1424: 'Luxe Essentials',
  1425: 'Private Label MFP Reserve',
  1426: 'Haute Hippie',
  1427: 'Rebecca Taylor',
  1428: 'Active',
  1429: 'Contemporary Collections',
  1430: 'Denim Collections',
  1431: 'Swim Consignment',
  1500: "Children's Apparel",
  1505: "Children's Apparel MFP Reserve",
  1510: "Children's Accessories",
  1515: "Children's Toys",
  1520: 'Baby Gear',
  1525: "Children's Accessories MFP Reserve",
  1530: 'Burberry',
  1535: 'Burberry MFP Reserve',
  1540: "Children's Apparel Consignment",
  1800: 'Foundations',
  1805: 'Foundations MFP Reserve',
  1825: 'Sleepwear & Lounge',
  1830: 'Sleepwear & Lounge MFP Reserve',
  1835: 'Private Label Cashmere & Silks Collections',
  1840: 'Private Label Intimate Collections MFP Reserve',
  1845: 'Hosiery & Slippers',
  1850: 'Hosiery & Slippers MFP Reserve',
  2000: 'Owned Food',
  2001: 'Dropship Food',
  2002: 'Food & Gourmet MFP Reserve',
  2003: 'Accents',
  2004: 'Seating',
  2005: 'Bedroom',
  2006: 'Dining',
  2007: 'Rugs',
  2008: 'Furniture & Rugs MFP Reserve',
  2009: 'Decorative I',
  2010: 'Decorative II',
  2011: 'Decorative III',
  2012: 'Lighting',
  2013: 'Outdoor',
  2014: 'Jay Strongwater',
  2015: 'Wall',
  2016: 'Mackenzie Childs',
  2017: 'Monica Rich Home',
  2018: 'Home Decor MFP Reserve',
  2019: 'Paper',
  2020: 'Gifts/Desk/Books',
  2021: 'Home Office MFP Reserve',
  2022: 'Holiday',
  2023: 'Seasonal MFP Reserve',
  2024: 'Michael Aram',
  2025: 'Casual',
  2026: 'Crystal',
  2027: 'Flatware',
  2028: 'Formal',
  2029: 'Table Linens',
  2030: 'Tabletop MFP Reserve',
  2031: 'Bath',
  2032: 'Bed Linens',
  2034: 'Window Treatments',
  2035: 'Linens & Bath MFP Reserve',
  2037: 'Luggage',
  2039: 'Travel MFP Reserve',
  2040: 'Gifts & Home Consignment I',
  2041: 'Gifts & Home Consignment II',
  2042: 'Gifts & Home Consignment III',
  2043: 'Gifts & Home Consignment IIII',
  2044: 'Gifts & Home Consignment V',
  2045: 'Gifts & Home Consignment MFP Reserve',
  2046: 'Monica Rich Kosann Jewelry',
  2047: 'Monica Rich Kosann MFP Reserve',
  2048: 'Jonathan Adler',
  2049: 'Story',
  2050: 'Wine & Spirits',
  2051: 'Baccarat',
  2055: 'Kitchen',
  2060: 'Decorative IV',
  3400: 'Luxe Couture Shoes',
  3401: 'Special Orders/Trunk Shows Shoes 1',
  3402: 'Special Orders/Trunk Shows Shoes 2',
  3403: 'Special Orders/Trunk Shows Shoes 3',
  3404: 'Special Orders/Trunk Shows Shoes 4',
  3405: 'Valentino Shoes',
  3406: 'Special Orders/Trunk Shows Shoes MFP Reserve',
  3410: 'Luxe Designer Shoes',
  3415: 'YSL Shoes',
  3420: 'Advanced Designer I Shoes',
  3425: 'Tory Burch Shoes',
  3430: 'Advanced Designer II Shoes',
  3434: 'Active Shoes',
  3435: 'Advanced Contemporary Shoes',
  3440: 'Gucci Shoes',
  3445: 'Trend Contemporary Shoes',
  3450: 'Prada Shoes',
  3451: 'Classic Designer II',
  3455: 'Stuart Weitzman Shoes',
  3460: 'Christian Louboutin Shoes',
  3465: 'Classic Bridge Shoes',
  3470: 'Jimmy Choo Shoes',
  3475: 'Designer Shoes MFP Reserve',
  3480: 'Manolo Blahnik Shoes',
  3485: 'Contemporary Shoes MFP Reserve',
  3490: 'Chanel Shoes',
  3495: 'Classic Bridge Shoes MFP Reserve',
  3500: 'Chanel Accessories',
  3515: 'Chanel MFP Reserve',
  3520: 'Classic Italian Designer Handbags',
  3521: 'Balenciaga Handbags',
  3522: 'Givenchy Handbags',
  3523: 'Tom Ford Handbags',
  3524: 'Advanced French Designer Handbags',
  3525: 'Christian Dior',
  3526: 'Evening Designer Handbags',
  3527: 'Chloe Handbags',
  3528: 'Celine Handbags',
  3529: 'Goyard Handbags',
  3530: 'Gucci Handbags',
  3531: 'YSL Handbags',
  3532: 'Classic French Designer Handbags',
  3533: 'Luxe French Designer Handbags',
  3534: 'Trend French Designer Handbags',
  3535: 'Italian Designer I Handbags',
  3536: 'French Designer Handbags MFP Reserve',
  3537: 'Michael Kors Handbags',
  3538: 'Tory Burch Handbags',
  3539: 'Advanced Contemporary Handbags',
  3540: 'Advanced Italian Designer 2 Handbags',
  3541: 'Classic Contemporary Handbags',
  3542: 'Trend Contemporary Handbags',
  3543: 'Contemporary Handbags MFP Reserve',
  3544: 'Special Orders/Trunk Shows Handbags 1',
  3545: 'Italian Designer Handbags MFP Reserve',
  3546: 'Special Orders/Trunk Shows Handbags 2',
  3547: 'Special Orders/Trunk Shows Handbags 3',
  3548: 'Special Orders/Trunk Shows Handbags 4',
  3549: 'Special Orders/Trunk Shows Handbags MFP Reserve',
  3550: 'Bottega Veneta Handbags',
  3551: 'Valentino Handbags',
  3552: 'Fendi Handbags',
  3555: 'Prada Handbags',
  3556: 'Mansur Gavriel',
  3560: 'Advanced Italian Designer',
  3561: 'Prada Handbags Consignment',
  3562: 'Miu Miu Handbags Consignment',
  3600: 'Burberry Accessories',
  3601: 'Classic Accessories',
  3602: 'Gucci Accessories',
  3603: 'Hair Accessories',
  3604: 'Hermes Of Paris',
  3605: 'Loro Piana',
  3606: 'Accessories MFP Reserve',
  3607: 'Eyewear',
  3608: 'Eyewear MFP Reserve',
  3609: 'Special Orders/Trunks Shows Fashion Accessories I',
  3610: 'Special Orders/Trunks Shows Fashion Accessories II',
  3611: 'Special Orders/Trunks Shows Fashion Accessories III',
  3612: 'Special Orders/Trunk Shows Fahsion Accessories MFP Reserve',
  3613: 'Contemporary Accessories',
  3614: 'Couture Accessories',
  4400: 'Designer Shoes',
  4401: 'Luxe Shoes',
  4402: 'Casual Shoes',
  4403: 'Classic Shoes',
  4404: 'Gucci Shoes',
  4405: 'Prada Shoes',
  4406: 'Consignment Shoes',
  4407: 'Ferragamo Shoes',
  4408: "Men's Shoes MFP Reserve",
  4409: 'Shoe/Leather Special Orders',
  4410: 'Charvet',
  4411: 'Stefano Ricci',
  4412: 'Hermes',
  4413: 'Tom Ford Accessories',
  4414: 'Leather Accessories',
  4415: 'Jewelry/Watches',
  4416: 'Neckwear',
  4417: 'Soft Accessories',
  4418: 'Personal Furnishings',
  4419: 'Dress Shirts',
  4420: 'Sunglasses',
  4421: 'Gifts',
  4422: 'Accessories SO 2',
  4423: 'Accessories SO 1',
  4424: "Men's Accessories MFP Reserve",
  4425: 'Accessories SO 3',
  4426: 'Designer Sportswear SO',
  4427: 'Moncler',
  4428: 'Consignment Leather',
  4429: 'European Collections',
  4430: "Men's Designer RTW MFP Reserve",
  4432: 'Loro Piana',
  4433: 'Berluti',
  4434: 'Tom Ford Sportswear',
  4435: 'Cucinelli Sportswear',
  4436: 'Private Label',
  4437: 'Zegna Sportswear',
  4438: 'Luxury Sportswear 2',
  4439: 'Luxury Sportswear 1',
  4440: 'Trousers',
  4441: 'Luxury Sportswear 3',
  4442: "Men's Sportswear MFP Reserve",
  4443: 'Luxury Sportswear SO',
  4444: 'Kith',
  4445: 'Burberry',
  4447: 'Contemporary Collections',
  4449: 'Denim',
  4450: 'Contemporary SO',
  4451: "Men's Contemporary RTW MFP Reserve",
  4452: 'Classic',
  4453: 'Peter Millar',
  4455: "Men's Clothing Consigned 2",
  4456: "Men's Clothing Consigned 3",
  4458: 'Brioni Clothing',
  4459: 'Tom Ford Clothing',
  4460: 'Giorgio Armani Clothing',
  4461: 'Cucinelli Clothing',
  4464: 'Classic Clothing',
  4465: 'Zegna Clothing',
  4466: 'Modern Clothing',
  4467: 'Luxury Clothing',
  4468: 'Formal',
  4469: 'Topcoats',
  4470: 'Clothing Special Orders 2',
  4471: 'Clothing Special Orders 1',
  4472: "Men's Clothing MFP Reserve",
  4473: 'Chrome Hearts Accessories Consigned',
  4474: 'Chrome Hearts RTW Consigned',
  4475: 'Leather Accessories 2',
  4476: 'Neckwear 2',
  4477: 'Dress Shirts 2',
  4478: 'Accessories SO 4',
  4479: 'Consignment Leather 2',
  4480: 'NikeLab RTW',
  4481: 'NikeLab Footwear',
  4482: 'Consignment Shoes 2',
  4483: "Men's Accessories Consigned",
  4484: "Men's Clothing Consigned 1",
  4485: 'Chrome Hearts RTW Owned',
  4486: 'Chrome Hearts Accessories Owned',
  4487: 'GOAT',
  4488: 'Prada RTW Consignment',
  4489: 'Prada Leathergoods/Accessories Consignment',
  4490: 'Armani Clothing Consignment',
  4491: "Men's RTW Contemporary Consignment",
  5301: 'Cosmetics I',
  5302: 'Cosmetics II',
  5303: 'Cosmetics III',
  5304: 'Chanel Cosmetics',
  5305: 'Tom Ford Cosmetics',
  5306: 'Cosmetics MFP Reserve',
  5307: 'Treatment I',
  5308: 'Treatment II',
  5309: 'Treatment III',
  5310: 'Sisley',
  5311: 'La Prairie',
  5312: 'La Mer',
  5313: 'Treatment MFP Reserve',
  5314: 'Fragrance I',
  5315: 'Fragrance II',
  5316: 'Home Fragrance',
  5317: 'Creed',
  5318: 'Jo Malone',
  5319: 'Fragrance MFP Reserve',
  5320: 'Beauty Accessories',
  5321: 'Beauty Tools',
  5322: 'Beauty Accessories MFP Reserve',
  5323: 'Bath & Body',
  5324: 'Hair Care',
  5325: 'Bath, Body & Hair MFP Reserve',
  5326: 'Christian Louboutin',
  5327: 'Beauty Initiatives',
  5328: 'Private Label Home Fragrance',
  5329: 'Pat McGrath Labs',
  5330: 'Chantecaille',
  5331: 'Treatment IV',
  5600: 'David Yurman',
  5601: 'Purchased Consigned DY- ICE',
  5602: 'Ippolita',
  5603: 'Purchased Consigned Ippolita- ICE',
  5604: 'Designer Jewelry 1',
  5605: 'Purchased Consigned DJ 1- ICE',
  5606: 'Designer Jewelry 2',
  5607: 'Purchased Consigned DJ 2- ICE',
  5608: 'Trend DJ 3',
  5609: 'Purchased Consigned 5F/Trend DJ 3- ICE',
  5610: 'Timepieces',
  5611: '5F/Trend DJ3',
  5612: '5F/DJ 2',
  5613: 'DJ (HB) 2',
  5614: 'DJ (HB) 3',
  5615: 'Designer Jewelry Owned MFP Reserve',
  5616: 'Consigned David Yurman- ICE',
  5617: 'Consigned Ippolita- ICE',
  5618: 'Consigned DJ 1- ICE',
  5619: 'Consigned DJ 2- ICE',
  5620: 'Consigned DJ 2- Non ICE',
  5621: 'Consigned 5F/Trend DJ 3- ICE',
  5622: 'Timepieces Consigned- ICE',
  5623: 'Consigned Timepieces- Non ICE',
  5624: 'Designer Jewelry Consigned MFP Reserve',
  5625: 'Van Cleef & Arpels',
  5626: 'Designer PJ 1',
  5627: 'Estate PJ 1',
  5628: 'Precious Jewelry 1',
  5629: 'Private Label PJ 1',
  5630: 'PJ Gems 1',
  5631: 'Designer PJ 2',
  5632: 'Precious Jewelry 2',
  5633: 'Trades',
  5634: 'Designer PJ 3',
  5635: 'Wholesale',
  5636: 'Workroom',
  5637: 'Credit Accom',
  5638: 'Repairs',
  5639: 'PJ/Sample/Workroom',
  5640: 'Designer PJ Watches',
  5641: 'Precious Jewelry Owned MFP Reserve',
  5642: 'Consigned Van Cleef & Arpels',
  5643: 'Consigned Designer PJ 1',
  5644: 'Consigned Estate PJ 1',
  5645: 'Consigned PJ 1',
  5646: 'Consigned Private Label PJ 1',
  5647: 'Consigned PJ Gems 1',
  5648: 'Consigned Designer PJ 2',
  5649: 'Consigned PJ 2',
  5650: 'Consigned Designer PJ 3',
  5651: 'Consigned Designer PJ Watches',
  5652: 'Precious Jewelry Consigned MFP Reserve',
  5653: 'DJ (HB) 1',
  5655: 'Consigned David Yurman- Non ICE',
  5656: 'Consigned Ippolita- Non ICE',
  5657: 'Consigned DJ 1- Non ICE',
  5658: 'Consigned 5F/Trend DJ 3- Non -ICE',
  5659: 'Consigned Trend DJ 3- Non ICE',
  5660: 'Designer Jewelry Purchased Consigned MFP Reserve',
  5661: 'Consigned 5F/DJ 2-Non ICE',
  5662: 'Consigned 5F/DJ 2- ICE',
  5663: 'Purchased Consigned 5F/DJ 2- ICE',
  5664: 'Purchase Consigned MRK - ICE',
  5670: 'Consigned MRK - ICE',
  5675: 'Precious Jewelry Drop Ship',
  8100: 'Akris',
  8101: 'Chanel',
  8102: 'Escada',
  8103: 'Armani Black Label',
  8104: 'Dior/Maxwell/DelPozo',
  8105: 'Tom Ford',
  8106: 'Advanced Couture',
  8107: 'Rena Lange',
  8108: 'Couture Collections MFP Reserve',
  8109: 'Evening',
  8110: 'J. Mendel',
  8111: 'Valentino/AndrewGn',
  8112: 'Couture Modernist MFP Reserve',
  8113: 'Celine/Mouret/Beck',
  8114: 'The Row',
  8115: 'Brunello Cucinelli',
  8116: 'Balmain/Givenchy',
  8117: 'American Designer',
  8118: 'Balen/Chloe',
  8119: 'Alaia/Ricci/SL',
  8120: 'Ralph Lauren Collection',
  8121: 'Traditional Designer',
  8122: 'Designer Collections MFP Reserve',
  8123: 'Runhof/Gilbert',
  8124: 'Akris Punto',
  8125: 'Emporio Armani',
  8126: 'Michael Kors',
  8127: 'Alexander Mcqueen',
  8128: 'Jil Sander',
  8129: 'Advanced Designer',
  8130: 'Designer Modernist MFP Reserve',
  8131: 'Dolce & Gabbana',
  8132: 'Loro Piana',
  8133: 'Etro/Eskandar/MaxMara',
  8134: 'European Designer MFP Reserve',
  8135: 'Stella/Advanced',
  8136: 'Advanced Designer II',
  8137: 'Collezioni/Punto MFP Reserve',
  8138: 'American Modernist',
  8139: 'Marni/Jacobs',
  8140: 'Gucci',
  8141: 'Urban Zen',
  8142: 'Contemporary Fine Apparel',
  8143: 'Contemporary Fine Apparel MFP Reserve',
  8144: 'Owned Furs',
  8145: 'Consigned Furs',
  8146: 'Furs MFP Reserve',
  8147: 'Bridal',
  8148: 'Bridal MFP Reserve',
  8150: 'Fine Apparel Special Orders',
  8155: 'Carolina Herrera',
  8156: 'Oscar de la Renta',
  8160: 'Prada/Miu Miu',
  8161: 'Max Mara',
  8162: 'Burberry',
  8163: 'Giorgio Armani Consignment',
  8164: 'Modern Evening',
  8165: 'St. John',
  8166: 'Premiere Evening',
  8167: 'Brunello Cucinelli 2',
  8168: 'Thom Browne Consignment',
  8169: 'Prada Consignment',
  8170: 'Miu Miu Consignment',
};
